import { useRef, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

// Push-to-talk: records mic audio, sends to Whisper, returns the transcript via onText.
export function useRecorder({ onText, onState }) {
  const mediaRef = useRef(null);
  const [recording, setRecording] = useState(false);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks = [];
      recorder.ondataavailable = (e) => chunks.push(e.data);
      recorder.onstop = async () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        stream.getTracks().forEach(t => t.stop());
        onState?.("thinking");
        try {
          const fd = new FormData();
          fd.append("file", blob, "voice.webm");
          const { data } = await api.post("/stt", fd, { headers: { "Content-Type": "multipart/form-data" } });
          if (data.text) onText(data.text);
        } catch { toast.error("Transcription failed"); }
        finally { onState?.("idle"); }
      };
      recorder.start();
      mediaRef.current = recorder;
      setRecording(true);
      onState?.("listening");
    } catch { toast.error("Microphone access denied"); }
  };

  const stop = () => { mediaRef.current?.stop(); setRecording(false); };
  return { recording, toggle: recording ? stop : start };
}
